module.exports = __webpack_public_path__ + "img/loader.5c37b83f.gif";